'use strict';

wbApp.directive('wbStudentCompGrpLookup', ['$translate', '$timeout', '$q', 'studentSvc',
    function ($translate, $timeout, $q, studentSvc) {
        function formatResult(student) {
            if (!student) { return; }

            return "<div class='row'>" +
                        "<div class='col-md-6'>" + student.studentFullName + "</div>" +
                        "<div class='col-md-6'>" + student.compensationGroupName + "</div>" +
                    "</div>";
        }

        function formatSelection(student) {
            return student.studentFullName + ' - ' + student.compensationGroupName;
        }

        return {
            restrict: 'EA',
            require: 'ngModel',
            scope: {
                semesterId: '=',
                selectionChanged: '&onSelectionChanged',
                showClearButton: '='
            },
            link: function (scope, elm, attrs, controller) {

                var deferred = $q.defer();

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_STUDENT'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: scope.showClearButton,
                        query: function (query) {
                            studentSvc.getStudentsWithCompGrpLookupQuery(
                                query.term, 10, query.page, scope.semesterId, onSuccess, onError);

                            function onSuccess(data) {
                                query.callback({ results: data, more: data.length > 0 });
                            }

                            function onError() {
                                query.callback({ results: [], more: false });
                            }
                        },
                        initSelection: function (element, callback) {
                            function onSuccess(data) {
                                controller.$setViewValue(data.id);
                                callback(data);
                            }

                            function onError() {
                                callback(null);
                            }

                            var id = $(element).val();
                            if (!!id) {
                                studentSvc.getStudentsWithCompGrpLookupID(
                                    id, scope.semesterId, onSuccess, onError);
                            } else {
                                controller.$setViewValue(null);
                                callback(null);
                            }
                        }
                    });

                    controller.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function (e) {
                        scope.$apply(function () {
                            controller.$setViewValue(e.val);
                            if (scope.selectionChanged) {
                                scope.selectionChanged({ student: e.added });
                            }
                        });
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });


                    deferred.resolve(1);
                }, 1);

                controller.$render = function () {
                    deferred.promise.then(function () {
                        elm.select2('val', controller.$viewValue);
                    });
                };

            }
        }
}]);
